import React from "react";
import { FaXmark } from "react-icons/fa6";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { IoWarning } from "react-icons/io5";
import { MdError } from "react-icons/md";
import { GrStatusGood } from "react-icons/gr";
export default function AreYouSureModal({
  message,
  closeModal,
  okayButton,
  modalType = "warning",
}) {
  console.log(modalType);
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      okayButton(); // Call your function here
    }
  };

  if (modalType === "warning") {
    return (
      <section
        className="absolute bottom-4 sm:bottom-6 md:bottom-8 right-1 sm:right-2 w-[90%] sm:max-w-md md:max-w-lg lg:max-w-[25rem] h-auto flex flex-col items-start justify-start bg-white rounded-lg gap-2 border-2 border-[#FFC72C] shadow-lg"
        onKeyDown={handleKeyDown}
      >
        <section className="w-full flex text-center text-sm sm:text-base md:text-lg text-[#FFC72C] font-medium">
          {/* Warning Icon Section */}
          <div className="w-12 sm:w-14 md:w-16 flex items-center justify-center text-white bg-[#FFC72C] rounded-l-lg">
            <IoWarning className="text-xl sm:text-2xl md:text-3xl" />
          </div>

          {/* Message Content */}
          <p className="flex-1 text-left p-1 sm:p-2 md:p-3">
            {message}
          </p>

          {/* Close Button */}
          <button
            onClick={closeModal}
            className="p-3 flex items-center justify-center text-gray-600 hover:text-black"
          >
            <FaXmark className="text-lg sm:text-xl md:text-2xl" />
          </button>
        </section>
      </section>
    );
  }
  if (modalType === "error") {
    return (
      <section
        className="absolute bottom-4 sm:bottom-6 md:bottom-8 right-1 sm:right-2 w-[90%] sm:max-w-md md:max-w-lg lg:max-w-[25rem] h-auto flex flex-col items-start justify-start bg-white rounded-lg gap-2 border-2 border-[#f85353] shadow-lg"
        onKeyDown={handleKeyDown}
      >
        <section className="w-full flex text-center text-sm sm:text-base md:text-lg text-[#f85353] font-medium">
          {/* Warning Icon Section */}
          <div className="w-12 sm:w-14 md:w-16 flex items-center justify-center text-white bg-[#f85353] rounded-l-lg">
            <MdError className="text-xl sm:text-2xl md:text-3xl" />
          </div>

          {/* Message Content */}
          <p className="flex-1 text-left p-3 sm:p-4 md:p-5">{message}</p>

          {/* Close Button */}
          <button
            onClick={closeModal}
            className="p-3 flex items-center justify-center text-gray-600 hover:text-black"
          >
            <FaXmark className="text-lg sm:text-xl md:text-2xl" />
          </button>
        </section>
      </section>
    );
  }
  if (modalType === "success") {
    return (
      <section
        className="absolute bottom-4 sm:bottom-6 md:bottom-8 right-1 sm:right-2 w-[90%] sm:max-w-md md:max-w-lg lg:max-w-[25rem] h-auto flex flex-col items-start justify-start bg-white rounded-lg gap-2 border-2 border-[#5AC189] shadow-lg sm:block md:hidden"
        onKeyDown={handleKeyDown}
      >
        <section className="w-full flex text-center text-sm sm:text-base md:text-lg text-[#5AC189] font-medium">
          {/* Warning Icon Section */}
          <div className="w-12 sm:w-14 md:w-16 flex items-center justify-center text-white bg-[#5AC189] rounded-l-lg">
            <GrStatusGood className="text-xl sm:text-2xl md:text-3xl" />
          </div>

          {/* Message Content */}
          <p className="flex-1 text-left p-3 sm:p-4 md:p-5">{message}</p>

          {/* Close Button */}
          <button
            onClick={closeModal}
            className="p-3 flex items-center justify-center text-gray-600 hover:text-black"
          >
            <FaXmark className="text-lg sm:text-xl md:text-2xl" />
          </button>
        </section>
      </section>
    );
  }
  if (modalType === "functional") {
    return (
      <main
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        onKeyDown={handleKeyDown}
      >
        <section className="w-[24rem] h-auto flex flex-col items-start justify-start bg-white rounded gap-1">
          <header className="flex w-full p-2 items-center justify-end rounded-t-lg font-medium">
            <button onClick={closeModal}>
              <FaXmark />
            </button>
          </header>
          <section className="w-full flex flex-col text-center text-lg text-[#f85353] p-2 font-medium">
            <div className="w-full flex items-center justify-center text-lg">
              <HiOutlineExclamationCircle className="text-[#f85353] text-center text-xl" />
            </div>
            {message}
          </section>
          <footer className="flex justify-end items-center w-full p-2">
            <button
              className="border py-1 px-2 tracking-wide mr-2 text-gray-700 hover:bg-gray-100 rounded"
              onClick={closeModal}
            >
              Cancel
            </button>
            <button
              className={`border py-1 px-2 tracking-wide bg-[#f85353] text-white rounded`}
              onClick={okayButton}
            >
              Okay
            </button>
          </footer>
        </section>
      </main>
    );
  }
}
